import React, { Component } from "react";
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
  OverlayTrigger,
  ButtonToolbar,
  Popover
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Select from 'react-select';
import { customerActions } from 'redux/actions/customer-action';
import { Link } from 'react-router-dom';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { confirmAlert } from 'react-confirm-alert';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import { helperFunctions as HF } from 'helper/helperFunctions';

class CustomerListPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorted: '',
      filtered: '',
      pageSize: 10,
      list_status: 'all',
    }
  }

  customersPaginationData = (page = this.state.page, filtered = this.state.filtered, sorted = this.state.sorted, pageSize = this.state.pageSize) => {
    this.props.getCustomerDataCall(page, filtered, sorted, pageSize, this.state.list_status);
  }

  filterSearchHandle = (e) => {
      this.setState({
          'filtered': e.target.value
      }, () => {
          this.refReactTable.fireFetchData()
      });
  }

  deleteListItem(list_id) {
    const { initialState } = this.state;
    this.props.deleteCustomerCall(list_id).then(response => {
      this.props.getCustomerDataCall(this.props.current_page, this.state.filtered, '', this.state.pageSize, this.state.list_status);
    });
  }

  deleteConfirmItem(id) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Confirmalertfordelete typeName="Customer" onClosePro={onClose} deleteType={() => this.deleteListItem(id)} />
        )
      }
    })
  }

  handleDropdown = (selectedOption, name) => {
    console.log('seselec', selectedOption)
    this.setState({
      list_status: selectedOption.value
    }, () => {
      this.props.getCustomerDataCall(this.props.current_page, this.state.filtered, '', this.state.pageSize, this.state.list_status);
    });

  }

  handleCheckBox = (e, value) => {
    console.log('even check bo ', e.target, value)
    this.props.approveCustomerCall(value).then(res => {
      this.props.getCustomerDataCall(this.props.current_page, this.state.filtered, '', this.state.pageSize, this.state.list_status);
    })
  }
  render() {
    const { filtered } = this.state;
    const { customersData, loading, pages, } = this.props;
    let columns = [
      {
        Header: "Customers Listing",
        headerClassName: 'headerPagination',
        Cell: () => {
          return <div style={{ overflow: 'auto' }}></div>
        },
        columns: [
          {
            Header: 'Company Name',
            accessor: 'title',
            className: "action-center",
            sortable: false,
          },
          {
            Header: 'Contact Name',
            accessor: 'contact',
            Cell: row => {
              return (
                <div>
                  <span className="text-capitalize">{row.row.contact != undefined ? row.row.contact.first_name : ''}</span>
                  <span className="text-capitalize"> {row.row.contact != undefined ? row.row.contact.last_name : ''}</span>
                </div>
              )
            },
            className: "action-center",
            sortable: false,
          },
          {
            Header: 'Contact Email',
            accessor: 'contact.email',
            className: "action-center",
            sortable: false,
          },
          {
            Header: 'Brand Requested',
            accessor: 'brand_requested',
            className: "action-center",
            sortable: false,
          },
          {
            Header: 'Status',
            accessor: 'status',
            className: "action-center",
            sortable: false,
            Cell: ({ value, original }) => (
              <div>
                {
                  value === 1
                    ?
                    'Active'
                    :
                    <span>
                      <button
                        name="status"
                        type="button"
                        className="smallActionBtn m-sm btnSave"
                        onClick={(e) => { this.handleCheckBox(e, original.id) }} >
                        Approve
                      </button>
                    </span>
                }
              </div>
            )
          },
          {
            Header: "Actions",
            accessor: "id",
            Cell: ({ value }) => (
              <div>
                <ButtonToolbar>
                  <OverlayTrigger trigger="focus" placement="bottom" overlay={
                    <Popover id="tooltip">
                      <table className="table text-left actions_table">
                        <tbody>
                          <tr>
                            <td>
                              <Link to={'/Admin/' + value + '/customer-edit'} className=""><i className="fa fa-pencil" /> Edit</Link>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <button onClick={() => this.deleteConfirmItem(value)} className="btn_link text-danger"><i className="fa fa-trash text-danger " /> Delete</button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Link to={'/Admin/' + value + '/customer-permissions'} className=""><i className="fa fa-pencil" /> Brand access</Link>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Link to={'/Admin/customer/' + value + '/addresses'} className=""><i className="fa fa-pencil" /> Manage Addresses</Link>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Link to={'/Admin/customers/' + value + '/shipping-options'} className=""><i className="fa fa-pencil" /> Shipping Options</Link>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Link to={'/Admin/customer/' + value + '/contacts'} className=""><i className="fa fa-pencil" /> Contacts</Link>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Link to={'/Admin/customer/' + value + '/users'} className=""><i className="fa fa-pencil" /> Users</Link>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </Popover>
                  }>
                    <span>
                      <button type='button' className="action-button-size" ><i className="fa fa-bars" /></button>
                    </span>
                  </OverlayTrigger>
                </ButtonToolbar>

              </div>
            ),
            className: "action-center",
            sortable: false
          }
        ]
      }
    ];
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                ctTableResponsive
                content={
                  <div>
                    <Grid fluid>
                      <Row>
                        <Col md={12}>
                          <h3 style={{ textAlign: 'center', fontWeight: "500", textTransform: "capitalize" }}>Customers</h3>
                        </Col>
                        <Col md={12}>
                          <div className="flexElem mt-xlg flexResponsive" style={{ "alignItems": "flex-start", "justifyContent": "space-between" }}>
                            <div className="block">
                              <Link to="/Admin/add-customer" className="customBtn btnBlue m-md btn-lg">Add Customer</Link>

                            </div>
                            <div className="custom-search-input">
                              <FormInputs
                                ncols={["col-md-12"]}
                                onChange={this.filterSearchHandle}
                                proprieties={[
                                  {
                                    type: "text",
                                    bsClass: "form-control",
                                    placeholder: "Search Customers",
                                    onChange: this.filterSearchHandle,
                                    name: "filter"
                                  }
                                ]}
                              />
                            </div>
                          </div>


                          <div className="flexElem  flexResponsive" style={{ "alignItems": "flex-start", "justifyContent": "space-between" }}>
                            <div className="block">

                            </div>
                            <div className="custom-search-input">

                              <div className="flexElem alignCenter">
                                <div >
                                  <label htmlFor="" style={{ 'whiteSpace': 'nowrap', marginRight: '7px' }}> Customer Status: </label>
                                </div>
                                <div className="block">
                                  <Select
                                    value={HF.returnLabelWithValue(this.state.list_status, OC.CUSTOMER_LIST_OPTIONS)}
                                    name={'operand_attribute'}
                                    onChange={this.handleDropdown}
                                    options={OC.CUSTOMER_LIST_OPTIONS}
                                    className='text-capitalize'
                                    isSearchable={true}
                                    isMulti={false}
                                    placeholder={'Choose Attribute'}
                                    isClearable={false}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md={12} className="mt-xlg">
                          <ReactTable
                            noDataText='No data found'
                            data={customersData}
                            pages={pages}
                            loading={loading}
                            columns={columns}
                            defaultPageSize={10}
                            className="-striped listing responsive"
                            pageData={this.customersPaginationData}
                            ref={(refReactTable) => {this.refReactTable = refReactTable;}}
                            manual
                            onFetchData={(state, instance) => {
                                var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                state.pageData(state.page + 1, this.state.filtered, sort, state.pageSize);
                            }}
                          />
                        </Col>
                      </Row>
                    </Grid>
                  </div>
                } />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return ({
    getCustomerDataCall: (page, filter, sort, pageSize, status) => { dispatch(customerActions.getCustomerPagination(page, filter, sort, pageSize, status)) },
    deleteCustomerCall: data => {
      return dispatch(customerActions.deleteCustomer(data));
    },
    approveCustomerCall: (id) => { return dispatch(customerActions.approveCustomer(id)) },
  });
};

function mapStateToProps(state) {
  const { customersData, loading, pages, current_page } = state.customerReducer;
  return {
    customersData, loading, pages, current_page
  };
}

const CustomerList = connect(mapStateToProps, mapDispatchToProps)(CustomerListPage);
export default CustomerList;



// WEBPACK FOOTER //
// ./src/components/Admin/Customers/CustomerList.jsx